module.exports = __webpack_public_path__ + "static/media/syndicate.041f0ab4.svg";